<!-- #259 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Mapping OMS Channel
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      :headers="headers"
      :items="channelMapping"
      :loading="loader"
      :options.sync="options"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [25, 50, 100, 250],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <v-row class="mt-0">
          <v-col
            cols="12"
            md="6"
            class="d-flex flex-column align-left justify-center pt-0"
          >
            <v-toolbar-title class="pl-4 text-h6">
              OMS Channel
            </v-toolbar-title>
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-end">
            <v-btn
              color="primary"
              dark
              class="mb-2 text-end mr-4"
              small
              v-if="
                checkPermission('app_ecom_vendors:fulfillment_storer_sync') &&
                selectedClientId &&
                $store.getters.user.user_category == 3 &&
                showSync
              "
              @click="addSyncFunction()"
              >Sync</v-btn
            >
            <v-btn
              color="primary"
              dark
              class="mb-2 text-end mr-4"
              small
              v-if="
                checkPermission(
                  'app_ecom_vendors:fulfillment_client_channel_mapping'
                ) && selectedClientId
              "
              @click="addClientMapping()"
              >Add Mapping Details</v-btn
            >

            <v-autocomplete
              v-model="selectedClientId"
              label="Name"
              class="pt-0 pr-4"
              item-text="name"
              item-value="id"
              :items="clients"
              @focus="fetchClientList"
              @change="fetchchannelMapping(), getwarehouse(selectedClientId)"
              dense
              outlined
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <v-dialog
          v-model="dialog"
          max-width="650px"
          @keydown.esc="close"
          persistent
        >
          <v-card>
            <v-toolbar flat style="height: 45px">
              <v-toolbar-title>
                <span
                  >{{ formTitle }} Client - Channel mapping
                  <i class="caption red--text ml-4"> * required field</i></span
                >
              </v-toolbar-title>
            </v-toolbar>

            <v-divider class="mt-3"></v-divider>
            <v-card-text class="pb-0">
              <v-container>
                <v-form ref="form">
                  <v-row v-if="selectedClient.service == 'b2b_fulfillment'">
                    <v-col cols="12" sm="6" md="6">
                      <v-autocomplete
                        v-model="editedChannel.warehouse_id"
                        label="Warehouse Name"
                        :rules="[(v) => !!v || 'Warehouse Name is required.']"
                        item-text="name"
                        item-value="id"
                        class="required"
                        :items="warehouses"
                        outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-autocomplete
                        v-model="editedChannel.infor_storer_id"
                        label="Storer Name"
                        :rules="[(v) => !!v || 'Storer Name is required.']"
                        item-text="storer_name"
                        item-value="id"
                        class="required"
                        :items="stores"
                        outlined
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row v-else>
                    <v-col cols="12" sm="6" md="6">
                      <v-autocomplete
                        v-if="editedIndex == -1"
                        v-model="editedChannel.channel_name"
                        label="Channel Name"
                        :rules="[
                          (v) =>
                            (v !== '' && v !== null) ||
                            'Channel name is required.',
                        ]"
                        class="required"
                        :items="channels"
                        @focus="fetchChannelList"
                        :loader="fetchChanneloader"
                        outlined
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        v-model="editedChannel.channel_code"
                        label="Channel code"
                        outlined
                        :rules="[
                          (v) =>
                            (v && !!v.trim()) || 'Channel code is required',
                        ]"
                        class="required"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row> </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions class="pl-8 pt-0 pb-6">
              <v-btn color="primary" @click="save" :loading="saveLoader">
                {{ editedIndex === -1 ? "Add" : "Update" }}
              </v-btn>
              <v-btn color="primary" class="error" @click="close">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:[`item.active`]="{ item }">
        <span v-if="item.active == true">
          <v-switch
            v-model="item.active"
            @click="editItem(item)"
            v-if="
              checkPermission(
                'app_ecom_vendors:fulfillment_channel_mapping_change_status'
              )
            "
          ></v-switch>
        </span>
        <span v-else>
          <v-tooltip
            bottom
            v-if="checkPermission('app_ecom_vendors:fulfillment_channel_check')"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                @click="checkMapping(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-key-plus
              </v-icon>
            </template>
            <span>Check Mapping</span>
          </v-tooltip>
        </span>
      </template>
    </v-data-table>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { countries } from "@/config/data";

export default {
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? " Add" : "Edit";
    },
    ...mapGetters(["activeCarriersListTypes", "userCategory"]),
    allCountries() {
      return Object.keys(countries).map((i) => {
        return {
          text: countries[i],
          value: i,
        };
      });
    },
  },
  created() {
    this.selectedClientId = this.$route.params.id;
    if (this.$store.getters.user.user_category == 1) {
      this.selectedClientId = this.$store.getters.user.id;
      this.getwarehouse(this.selectedClientId);
    }
    this.fetchClientList();
    // this.fetchChannelList();
  },
  data: () => ({
    fetchChanneloader: false,
    clients: [],
    selectedClientId: "",
    dialogDelete: false,
    facilityList: [],
    headers: [
      {
        text: "Channel Name",
        value: "channel_name",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Channel Code",
        value: "channel_code",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Warehouse Name",
        value: "warehouse_name",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Storer Name",
        value: "infor_storer_storer_name",
        class: "body-1 font-weight-bold",
      },
      {
        text: "Status",
        value: "active",
        class: "body-1 font-weight-bold",
      },
    ],
    channelMapping: [],
    options: {},
    total: 0,
    channelMappingLoader: false,
    statusLoader: false,
    editedIndex: -1,
    editedChannel: {
      client_facility_code_in_oms: "",
      client_code_in_oms: "",
      active: false,
      click_dna_client_id: "",
      channel_name: "",
      client_name_in_oms: "",
    },
    saveLoader: false,
    dialog: false,
    channel_name: "",
    loader: false,
    channels: [],
    syncloader: false,
    stores: [],
    selectedClient: { service: "" },
    warehouses: [],
    showSync: false,
  }),

  watch: {
    options: {
      handler() {
        this.fetchchannelMapping();
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions([
      "getchannelMapping",
      "snackBar",
      "createClientMapping",
      "updatechannelMapping",
      "fetchClient",
      "getclientChannelList",
      "checkClientMapping",
      "getInforStoreList",
      "getInforWarehouseListBB",
      "syncMapping",
    ]),
    addSyncFunction() {
      this.syncMapping()
        .then((res) => {
          this.snackBar({
            color: "green",
            message: res.data.message,
          });
          this.fetchchannelMapping();
          this.getwarehouse(this.selectedClientId);
        })
        .catch(() => {});
    },
    getwarehouse(id) {
      this.getInforWarehouseListBB(id).then((response) => {
        this.warehouses = response.data.result;
      });
    },
    fetchChannelList() {
      this.fetchChanneloader = true;
      this.getclientChannelList()
        .then((response) => {
          this.fetchChanneloader = false;
          this.channels = response.data.data;
        })
        .catch(() => {
          this.fetchChanneloader = false;
        });
    },
    fetchClientList() {
      if (this.clients.length === 0 && this.userCategory.user_category === 3) {
        this.clientLoader = true;
        this.fetchClient({
          fields: "id,name,service",
          pagination: 0,
          service: "fulfillment,fulfillment_wid_last_mile,b2b_fulfillment",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    fetchchannelMapping() {
      if (this.selectedClientId) {
        this.selectedClient = this.clients.find(
          (e) => e.id == this.selectedClientId
        );
        if (this.selectedClient.service == "b2b_fulfillment") {
          this.showSync = true;
          this.getInforStoreList().then((response) => {
            this.stores = response.data.result;
          });
        } else {
          this.showSync = false;
        }
        this.channelMapping = [];
        this.channelMappingLoader = true;
        let data = {
          client_id: this.selectedClientId,
          params: this.options,
        };
        this.getchannelMapping(data)
          .then((res) => {
            this.channelMappingLoader = false;
            this.channelMapping = res.data;
            // this.total = res.data.total;
          })
          .catch(() => {
            this.channelMappingLoader = false;
          });
      }
    },
    closeConfirm() {
      this.dialogDelete = false;
    },
    addClientMapping() {
      if (this.selectedClientId == undefined) {
        this.snackBar({
          color: "error",
          message: "Client is required",
        });
      } else {
        this.dialog = true;
      }
    },

    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saveLoader = true;

      let data = {
        oms_vendors_status: this.editedChannel.active,
      };
      if (this.editedChannel.warehouse_id) {
        this.editedChannel.oms_vendor_id = this.warehouses.find(
          (warehouse) => warehouse.id === this.editedChannel.warehouse_id
        ).f_id;
      }
      if (this.editedIndex > -1) {
        this.updatechannelMapping({
          id: this.channel_name,
          data: data,
        })
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.dialog = false;
            this.editedIndex = -1;
            this.editedChannel = {};

            this.fetchchannelMapping();
          })
          .catch(() => {
            this.dialog = false;
            this.editedIndex = -1;
            this.editedChannel = {};

            this.saveLoader = false;
          });
      } else {
        if (this.selectedClient.service == "b2b_fulfillment") {
          delete this.editedChannel.click_dna_client_id;
          delete this.editedChannel.client_facility_code_in_oms;
          delete this.editedChannel.client_code_in_oms;
          delete this.editedChannel.active;
          delete this.editedChannel.channel_name;
          delete this.editedChannel.client_name_in_oms;
          delete this.editedChannel.channel_code;
        } else {
          delete this.editedChannel.infor_storer_id;
        }
        this.editedChannel.client_id = this.selectedClientId;
        this.createClientMapping({
          params: this.editedChannel,
        })
          .then((res) => {
            this.saveLoader = false;
            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.dialog = false;
            this.fetchchannelMapping();
            this.editedChannel = {};
          })
          .catch(() => {
            this.saveLoader = false;
            this.dialog = false;
          });
      }
    },
    checkMapping(item) {
      let data = {
        channel_id: item.id,
      };
      this.checkClientMapping({
        params: data,
      }).then((res) => {
        this.saveLoader = false;
        this.snackBar({
          color: "success",
          message: res.data.message,
        });
        this.fetchchannelMapping();
      });
    },
    editItem(item) {
      this.editedIndex = this.channelMapping.indexOf(item);
      this.editedChannel = Object.assign({}, item);
      this.channel_id = item.id;

      this.updatechannelMapping({
        id: this.channel_id,
      })
        .then((res) => {
          this.saveLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });
          this.dialog = false;
          this.editedIndex = -1;
          this.editedChannel = {};

          this.fetchchannelMapping();
        })
        .catch(() => {
          this.dialog = false;
          this.editedIndex = -1;
          this.editedChannel = {};
          this.saveLoader = false;
        });
    },
    close() {
      this.dialog = false;
      this.editedIndex = -1;
      this.editedChannel = {};
      this.$refs.form?.reset();
    },
  },
};
</script>
